import { render, staticRenderFns } from "./ResultsPerSeller.vue?vue&type=template&id=46fdf69b&"
import script from "./ResultsPerSeller.vue?vue&type=script&lang=js&"
export * from "./ResultsPerSeller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports